import Component from '../../shared/component';

export default class LogoutLink extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$element.on('click.logoutLink', this.handleClick);
  }

  unbindEvents() {
    this.$element.off('click.logoutLink', this.handleClick);
  }

  handleClick() {
    if (window.batchSDK) {
      window.batchSDK((api) => {
        api.setCustomUserID(null);
      });
    }
  }
}
